import React from 'react';

const DiagnosticsComponentLoadable = React.lazy(() => import('./DiagnosticsComponent'));

export { DiagnosticsComponentLoadable };
